const glazyDoubleWidthTypes = ['100', '120', '144'];

export default glazyDoubleWidthTypes;
